import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-mist border-t-2 border-abyssal">
      <div className="cv-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <img
              src="/logo/logo-horizontal.svg"
              alt="Costa Valente"
              data-testid="footer-logo"
              className="mb-6 h-8 w-auto"
              width="218"
              height="32"
            />
            <p className="text-steel text-sm leading-relaxed mb-6">
              {t(
                'Trading Company especializada em comércio exterior com atuação estratégica, consultiva e operacional completa em importação.',
                'Trading Company specialized in international trade with strategic, consultative and complete operational support in imports.'
              )}
            </p>
            <div className="flex items-center gap-2">
              <span className="h-px w-6 bg-brass" aria-hidden="true"></span>
              <span className="text-[10px] font-semibold uppercase tracking-[0.3em] text-brass">
                {t('Soluções em comércio exterior', 'International trade solutions')}
              </span>
            </div>
          </div>

          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-abyssal mb-5">
              {t('Links', 'Links')}
            </h3>
            <ul className="space-y-3">
              {[
                { to: '/', pt: 'Início', en: 'Home' },
                { to: '/sobre', pt: 'Sobre', en: 'About' },
                { to: '/servicos', pt: 'Serviços', en: 'Services' },
                { to: '/blog', pt: 'Blog', en: 'Blog' },
                { to: '/contato', pt: 'Contato', en: 'Contact' },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-steel hover:text-cobalt transition-colors text-sm">
                    {t(link.pt, link.en)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-abyssal mb-5">
              {t('Serviços', 'Services')}
            </h3>
            <ul className="space-y-3">
              {[
                { pt: 'Importação por Conta e Ordem', en: 'Import on Behalf' },
                { pt: 'Importação por Encomenda', en: 'Import by Order' },
                { pt: 'Assessoria Completa', en: 'Full Consulting' },
                { pt: 'Habilitação RADAR', en: 'RADAR Registration' },
                { pt: 'Inteligência Tributária', en: 'Tax Intelligence' },
              ].map((s) => (
                <li key={s.pt}>
                  <Link to="/servicos" className="text-steel hover:text-cobalt transition-colors text-sm">
                    {t(s.pt, s.en)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-abyssal mb-5">
              {t('Contato', 'Contact')}
            </h3>
            <div className="space-y-4">
              <a href="mailto:costavalente@costavalente.com.br" className="flex items-start gap-3 group">
                <Mail className="h-5 w-5 text-cobalt flex-shrink-0 mt-0.5" />
                <span className="text-steel group-hover:text-cobalt transition-colors text-sm">
                  costavalente@costavalente.com.br
                </span>
              </a>
              <a href="https://wa.me/5527996482098" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 group">
                <Phone className="h-5 w-5 text-cobalt flex-shrink-0 mt-0.5" />
                <span className="text-steel group-hover:text-cobalt transition-colors text-sm">
                  +55 27 99648-2098
                </span>
              </a>
              <div className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-cobalt flex-shrink-0 mt-0.5" />
                <p className="text-steel text-sm leading-relaxed">
                  COSTA VALENTE TRADING LTDA<br />
                  Rod. Gov. Mário Covas, 256, KM 280<br />
                  Portaria B, Sala 168, Padre Mathias<br />
                  Cariacica/ES — CEP 29.157-100<br />
                  CNPJ: 54.517.905/0001-62
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#E6E6ED] mt-14 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-steel-400 text-xs">
            &copy; {new Date().getFullYear()} Costa Valente Trading LTDA — CNPJ 54.517.905/0001-62
          </p>
          <p className="text-steel-400 text-xs">
            {t(
              'Trading Company · Espírito Santo, Brasil',
              'Trading Company · Espírito Santo, Brazil'
            )}
          </p>
        </div>
      </div>
    </footer>
  );
};
